export class MenuItemToppingRule {
    public static LEAST_EXPENSIVE = 'LEAST_EXPENSIVE';
    public static MOST_EXPENSIVE = 'MOST_EXPENSIVE';
}
